export default {
  metaTitle: '店铺自定义品类',
  pageTitle: '店铺自定义品类',
  addCategory: '添加店内分类',
  categoryName: '分类名',
  editCategory: '编辑分类',
  storeCategoryId: '店内分类id',
  storeCategoryName: '店内分类名',
  index: '排序值',
  indexTip: '数值越大，分类在店铺分类页面中显示的位置越靠前。',
  listings: 'Listings',
  operation: '操作',
  deleteCategory: '删除分类',
  nameNot: '未填写名称!',
  addSuccess: '增添成功!',
  duplicateName: '分类名重复',
  editSuccess: '修改成功!',
  deleteComfrim: '您确认要删除吗?',
  deleteSuccess: '删除成功!'
}
